import angular from 'angular';
import accountSettingsModule from '../accountSettingsModule';

function accountSettingsModalSocialDisconnectController(
  $scope,
  $uibModalInstance,
  accountsService,
  modalData,
  modalConstantsService
) {
  'ngInject';

  angular.extend($scope, modalData);
  $scope.data = {};
  $scope.layout = {
    isProcessing: false,
    error: ''
  };

  $scope.getTitle = function() {
    return modalConstantsService.socialDisconnect.unlinkTitle($scope.provider);
  };

  $scope.getPasswordErrorMessage = function(form) {
    if (form.$pristine && $scope.layout.error) {
      return $scope.layout.error;
    }
    return null;
  };

  $scope.hasPasswordError = function() {
    return $scope.layout.error !== '';
  };

  $scope.clearPasswordError = function() {
    $scope.layout.error = '';
  };

  $scope.submit = function(form) {
    form.$setPristine();
    $scope.clearPasswordError();

    $scope.layout.isProcessing = true;

    accountsService
      .beginUpdateSocialDisconnect($scope.provider, $scope.data.password)
      .then(
        function() {
          $uibModalInstance.close(true);
        },
        function(error) {
          $scope.layout.error = modalConstantsService.socialDisconnect.getMessageFromError(error);
        }
      )
      .finally(function() {
        $scope.layout.isProcessing = false;
      });
  };

  $scope.dismiss = function() {
    $uibModalInstance.dismiss();
  };
}

accountSettingsModule.controller(
  'accountSettingsModalSocialDisconnectController',
  accountSettingsModalSocialDisconnectController
);

export default accountSettingsModalSocialDisconnectController;
